import { store } from '../../store'

export const deleteCourseTopic = async ( id: number ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/courses/topics/${ id }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'DELETE'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'DELETE_COURSE_TOPIC_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'DELETE_COURSE_TOPIC_UNAUTHORIZED' } )
        return

    }

    if ( response.status === 500 ) {

        store.dispatch( { type: 'DELETE_COURSE_TOPIC_ERROR' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'DELETE_COURSE_TOPIC_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'DELETE_COURSE_TOPIC_OK' } )

}